module.exports = __webpack_public_path__ + "static/media/no-floor.79e178fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-floor.png
// module id = 228
// module chunks = 0